var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Projects',{staticClass:"pb-4"}),_c('v-row',[_c('v-col',{attrs:{"cols":"12","md":"6"}},[_c('Notifications')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }